import { $createLinkNode } from '@lexical/link'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $createMergeTagNode } from '@web/components/page-components/Text'
import { MergeFieldSetting, MergeTagType } from '@web/graphql-types'
import {
  $createTextNode,
  $getSelection,
  $insertNodes,
  $isRangeSelection,
  $isTextNode,
  createCommand,
  LexicalCommand,
} from 'lexical'
import { useCallback, useEffect } from 'react'

type CommandPayload = Partial<MergeFieldSetting>
export const INSERT_MERGE_TAG: LexicalCommand<CommandPayload> = createCommand('INSERT_MERGE_TAG')

const MergeTagPlugin = () => {
  const [editor] = useLexicalComposerContext()

  const createMergeTag = useCallback(
    (payload: CommandPayload) => {
      editor.update(() => {
        if (payload.MergeTagType === MergeTagType.Link) {
          const linkNode = $createLinkNode(
            `https://ge-merge-tag-start${payload.MergeFieldSettingId ?? ''}ge-merge-tag-end`,
          )
          const textNode = $createTextNode(payload.MergeTagDisplayText ?? '')
          linkNode.append(textNode)
          $insertNodes([linkNode])
          return
        }

        let format = 0
        let styles: Record<string, string> = {}

        const selection = $getSelection()
        if ($isRangeSelection(selection)) {
          const anchorNode = selection.anchor.getNode()
          const textNode = $isTextNode(anchorNode)
            ? anchorNode
            : (anchorNode.getPreviousSibling() ?? anchorNode.getNextSibling())

          if (textNode && $isTextNode(textNode)) {
            format = textNode.getFormat()
            styles = Object.fromEntries(
              textNode
                .getStyle()
                .split(';')
                .filter(Boolean)
                .map((s) => s.split(':') as [string, string]),
            )
          }
        }

        $insertNodes([$createMergeTagNode(payload, format, styles)])
      })
    },
    [editor],
  )

  useEffect(() => {
    const removeListener = editor.registerCommand(
      INSERT_MERGE_TAG,
      (payload) => {
        createMergeTag(payload)

        return true
      },
      0,
    )

    return () => removeListener()
  }, [editor, createMergeTag])

  return null
}

export { MergeTagPlugin }
